import { put, call, take, fork } from 'redux-saga/effects'
import { LLMUpdateChatMessageService } from '../../api/llm'
import { llmUpdateChatMessageSuccess } from '../../reducers/llm/action'
import { UPDATE_CHAT_MESSAGE } from '../../reducers/llm/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* updateChatMessageFlow(payload) {
  try {
    const { chatId, outline, callback } = payload

    const response = yield call(LLMUpdateChatMessageService, chatId, outline)

    yield put(llmUpdateChatMessageSuccess(response == '' ? outline : response))
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* updateChatMessageWatcher() {
  while (true) {
    const action = yield take(UPDATE_CHAT_MESSAGE)
    const { payload } = action

    yield fork(generalSaga, updateChatMessageFlow, payload, false)
  }
}
